import React from 'react';

const newsItems = [
  "🎮 Welcome to Social BreakMeAI!",
  "🎯 Bounty Challenge: Social engineering against AI",
  "🌟 Special events coming soon!"
];

export default function ScrollingInfo() {
  // Duplicate the items array to ensure continuous scrolling
  const duplicatedItems = [...newsItems, ...newsItems];
  const content = duplicatedItems.map(item => `<span>${item}</span>`).join('');

  return (
    <div className="scrolling-info">
      <div 
        className="scrolling-content" 
        dangerouslySetInnerHTML={{ __html: content + content }} // Double the content for seamless loop
      />
    </div>
  );
} 